document.addEventListener('page:loaded', function() {
  function updateFreeShippingProgress(cart) {
    var blocks = document.querySelectorAll('[data-free-shipping]');
    if (!blocks.length) return;

    var cartTotal = cart && typeof cart.total_price !== 'undefined' ? cart.total_price : null;
    if (cartTotal === null) return;

    blocks.forEach(function(block) {
      var threshold = parseInt(block.getAttribute('data-threshold'), 10) || 0;
      var locale = block.getAttribute('data-locale') || 'cs';
      var textBefore = block.getAttribute('data-text-before') || '';
      var textAfter = block.getAttribute('data-text-after') || '';
      var textDone = block.getAttribute('data-text-done') || '';

      var textEl = block.querySelector('[data-free-shipping-text]');
      var fillEl = block.querySelector('[data-free-shipping-fill]');

      if (!threshold || !textEl || !fillEl) return;

      var remaining = threshold - cartTotal;
      var progress = Math.max(0, Math.min(100, (cartTotal / threshold) * 100));
      var remainingFormatted = theme.Currency.formatMoney(remaining, theme.settings.moneyFormat);

      if (remaining > 0) {
        if (locale === 'en') {
          textEl.innerHTML = textBefore + ' <strong>' + remainingFormatted + '</strong> ' + textAfter;
        } else if (locale === 'de') {
          textEl.innerHTML = textBefore + ' <strong>' + remainingFormatted + '</strong> ' + textAfter;
        } else {
          textEl.innerHTML = textBefore + ' <strong>' + remainingFormatted + '</strong>';
        }
      } else {
        textEl.innerHTML = '<strong>' + textDone + '</strong>';
      }

      fillEl.style.width = progress + '%';
    });
  }

  function refreshFreeShippingProgress() {
    if (!theme.cart || !theme.cart.getCart) return;

    theme.cart.getCart().then(function(cart) {
      updateFreeShippingProgress(cart);
    });
  }

  refreshFreeShippingProgress();

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      setTimeout(function() {
        updateFreeShippingProgress(event.detail.cart);
      }, 150);
    } else {
      setTimeout(refreshFreeShippingProgress, 150);
    }
  });

  document.addEventListener('ajaxProduct:added', function() {
    setTimeout(refreshFreeShippingProgress, 250);
  });

  document.addEventListener('drawerOpen', function() {
    setTimeout(refreshFreeShippingProgress, 250);
  });
});